<template>
    <div class="col-md-12">
        <div class="panel-body">
            <pim-header @show-slot-content="handleFormState" :create-event="true" create-button-text="Add FTP credentials" header="FTP Credentials">
                <transition name="fade">
                    <div v-if="form.open" class="form-horizontal throttle">
                        <div v-for="group in channel.items" :key="group.groupingName">
                            <input-loader :fields="group.groupItems"></input-loader>
                        </div>
                        <div class="form-group row">
                            <div class="col-md-9 ml-auto text-right">
                                <button v-on:click="saveFtp()" type="button" class="btn btn-primary">Save</button>
                                <button v-on:click="dismissFtp()" type="button" class="btn btn-secondary">Cancel</button>
                            </div>
                        </div>
                    </div>
                </transition>
            </pim-header>
            <product-alerts :status="alert" v-model="alert"></product-alerts>
            <div>
                <transition name="vue-table-loader">
                    <div class="vue-table-loader" v-if="tableLoading">
                        <span class="fa fa-cog fa-spin fa-3x"></span>
                    </div>
                </transition>
                <div class="dataTables_wrapper container-fluid dt-bootstrap4 modern">
                    <vuetable
                        ref="vuetable"
                        :api-url="gridUrl"
                        :fields="fields"
                        :css="css.table"
                        :per-page="perPage"
                        :sort-order="sortOrder"
                        noDataTemplate="No FTP Credentials Found"
                        pagination-path=""
                        @vuetable:pagination-data="onPaginationData"
                        @vuetable:loaded="onLoaded"
                    >
                        <template slot="server" slot-scope="props">
                            <input
                                v-model="editedItem.server" :autofocus="true" v-if="props.rowData.id === editedIndex">
                            <span v-else>{{props.rowData.server}}</span>
                        </template>
                        <template slot="username" slot-scope="props">
                            <input
                                v-model="editedItem.username" :autofocus="true" v-if="props.rowData.id === editedIndex">
                            <span v-else>{{props.rowData.username}}</span>
                        </template>
                        <template slot="password" slot-scope="props">
                            <input
                                v-model="editedItem.password" :autofocus="true" v-if="props.rowData.id === editedIndex">
                            <span v-else>{{props.rowData.password}}</span>
                        </template>
                        <template slot="filepath" slot-scope="props">
                            <input
                                v-model="editedItem.filepath" :autofocus="true" v-if="props.rowData.id === editedIndex">
                            <span v-else>{{props.rowData.filepath}}</span>
                        </template>
                        <template slot="archived" slot-scope="props">
                            <select
                                    v-model="editedItem.archived" :autofocus="true" v-if="props.rowData.id === editedIndex"
                            >
                                <option value="" disabled>Choose....</option>
                                <option v-for="option in channel.items[0].groupItems[4].options" :value="option.id">{{option.name}}</option>
                            </select>
                            <span v-else>{{props.rowData.archived == 1 ? "Yes" : "No"}}</span>
                        </template>
                        <template slot="unarchived_path" slot-scope="props">
                            <input
                                v-model="editedItem.unarchived_path" :autofocus="true" v-if="props.rowData.id === editedIndex">
                            <span v-else>{{props.rowData.unarchived_path}}</span>
                        </template>
                        <template slot="separator" slot-scope="props">
                            <select
                                v-model="editedItem.separator" :autofocus="true" v-if="props.rowData.id === editedIndex"
                            >
                                <option value="" disabled>Choose....</option>
                                <option v-for="option in channel.items[0].groupItems[6].options" :value="option.id">{{option.name}}</option>
                            </select>
                            <span v-else>{{props.rowData.separator}}</span>
                        </template>
                        <template slot="type" slot-scope="props">
                            <select
                                v-model="editedItem.type" :autofocus="true" v-if="props.rowData.id === editedIndex"
                            >
                                <option value="" disabled>Choose....</option>
                                <option v-for="option in channel.items[0].groupItems[7].options" :value="option.id">{{option.name}}</option>
                            </select>
                            <span v-else>{{props.rowData.type}}</span>
                        </template>
                        <template slot="transformer" slot-scope="props">
                            <select
                                v-model="editedItem.transformer" :autofocus="true" v-if="props.rowData.id === editedIndex"
                            >
                                <option value="" disabled>Choose....</option>
                                <option v-for="option in channel.items[0].groupItems[8].options" :value="option.id">{{option.name}}</option>
                            </select>
                            <span v-else>{{props.rowData.transformer}}</span>
                        </template>
                        <template slot="actions" slot-scope="props">
                            <div class="ftp-credentials__item-actions" v-if="props.rowData.id === editedIndex">
                                <button
                                    type="button"
                                    class="btn btn-info btn-actions align-items-center"
                                    @click="close">
                                    <i class="fa fa-times-circle fa-lg"></i>
                                </button>
                                <button
                                    type="button"
                                    class="btn btn-danger btn-actions align-items-center"
                                    @click.prevent="saveCredential">
                                    <i class="fa fa-floppy-o fa-lg"></i>
                                </button>
                            </div>
                            <div v-else class="ftp-credentials__item-actions">
                                <button
                                    type="button"
                                    class="btn btn-info btn-actions align-items-center"
                                    @click="editCredential(props.rowData)">
                                    <i class="fa fa-pencil-square-o fa-lg"></i>
                                </button>
                                <button
                                    type="button"
                                    class="btn btn-danger btn-actions align-items-center"
                                    @click.prevent="deleteCredential(props.rowData.id)">
                                    <i class="fa fa-trash fa-lg"></i>
                                </button>
                            </div>
                        </template>
                    </vuetable>
                    <div class="row">
                        <div class="col-md-6">
                            <base-pagination-info
                                :css="css.table"
                                ref="paginationInfo"
                            >
                            </base-pagination-info>
                        </div>
                        <div class="col-md-6">
                            <base-pagination  ref="pagination"
                                              @vuetable-pagination:change-page="onChangePage"
                            ></base-pagination>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="deleteCredentialModal" class="modal-wrapper">
                <div class="modal-bg" @click="deleteCredentialModal = false"></div>
                <div class="d-flex flex-column modal-inner p-4">
                    <div class="row mx-4 pb-1">
                        <p class="font-weight-bold">
                            Are you sure you want to delete this credential?
                        </p>
                    </div>
                    <div class="row mx-4 my-0 pb-0">
                        <div class="col-md-6 d-flex align-items-center">
                            <button type="button" class="btn my-2 btn-outline-primary" @click="deleteCredentialModal = false">
                                Cancel
                            </button>
                            <button type="button" class="btn ml-2 btn-danger" :disabled="loading" @click="confirmDeleteCredential">
                                Delete
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import TextField from "../generic/text-field";
    var base_url = window.location.protocol + "//" + window.location.host;
    import axios from 'axios';
    import PimHeader from '../generic/pim-header';
    import InputLoader from "../form/form-loader.vue";
    import getNestedProperty from "../../mixins/getNestedProperty";
    import maskSensitiveField from "../../mixins/maskSensitiveField";
    import ProductAlerts from '../products/product-details-alerts.vue';
    import BasePagination from '../tables/base-pagination.vue';
    import BasePaginationInfo from '../tables/base-pagination-info.vue';

    export default {
        name: "ftp-info-index",
        components: {
            TextField,
            'pim-header': PimHeader,
            "input-loader": InputLoader,
            'product-alerts': ProductAlerts,
            'base-pagination': BasePagination,
            'base-pagination-info': BasePaginationInfo,
        },
        mixins: [
            getNestedProperty,
            maskSensitiveField
        ],
        props: ['channelvalues'],
        data() {
            return {
                alert: {
                    message: '',
                    status: 'alert-danger',
                    timeOut: 60000
                },
                form: {
                    open: false
                },
                channel: {
                    items: [],
                },
                deleteCredentialModal: false,
                credentialToDelete: null,
                loading: false,
                tableLoading:true,
                fields: [
                    {
                        name: '__slot:server',
                        title: 'Server'
                    },
                    {
                        name: '__slot:username',
                        title: 'Username'
                    },
                    {
                        name: '__slot:password',
                        title: 'Password'
                    },
                    {
                        name: '__slot:filepath',
                        title: 'File'
                    },
                    {
                        name: '__slot:archived',
                        title: 'Is Archived'
                    },
                    {
                        name: '__slot:unarchived_path',
                        title: 'File Contained'
                    },
                    {
                        name: '__slot:separator',
                        title: 'Delimiter'
                    },
                    {
                        name: '__slot:type',
                        title: 'Protocol'
                    },
                    {
                        name: '__slot:transformer',
                        title: 'Transformer'
                    },
                    {
                        name: "__slot:actions",
                        titleClass: "actions-single-column"
                    }
                ],
                perPage: 10,
                amountsShown: [
                    { text: '10', value: 10 },
                    { text: '25', value: 25 },
                    { text: '50', value: 50 },
                    { text: '100', value: 100 }
                ],
                sortOrder: [
                    {
                        field: 'created_at',
                        direction: 'desc',
                    }
                ],
                editedIndex: -1,
                defaultItem: {},
                editedItem: {
                    id: 0,
                    server: '',
                    username:'',
                    password:'',
                    filename:'',
                    archived:'',
                    unarchived_path:'',
                    separator:'',
                    type:'',
                    transformer:''
                },
                css: {
                    table: {
                        tableClass: 'table table-striped table-bordered table-middle',
                        ascendingIcon: 'sort-icon-asc',
                        descendingIcon: 'sort-icon-desc',
                        infoClass: '',
                    },
                },
                baseUrl: base_url
            }
        },
        computed:{
            gridUrl() {
                return route('ftp.credentials.grid');
            },
        },
        methods: {
            handleFormState(e) {
                this.form.open = !this.form.open;
            },
            saveFtp: function () {
                this.loading = true;
                var postData = {
                    currentTab: this.currentTab,
                    items: []
                };

                var ftpSpecificData = this.channel.items;
                if (ftpSpecificData) {
                    postData.items.push(...ftpSpecificData);
                }

                axios.post(`${baseURL}/ftp_credentials`, {
                    'data': postData
                })
                .then(function (response) {
                    this.loading = false;
                    this.alert.status = "alert-success";
                    this.alert.message = "Channel successfully saved";
                    this.form.open = !this.form.open;
                    this.setItems();
                    this.$refs.vuetable.refresh();
                }.bind(this))
                .catch(function (error) {
                    this.loading = false;
                    this.alert.status = "alert-danger";
                    this.alert.message = error.response ? error.response.data.message : 'An Error Occurred';
                    if ((typeof error.response.data.redirect_url !== 'undefined')) {
                        setTimeout(function () {
                            window.location.href = error.response.data.redirect_url;
                        }, 8000);
                    }
                }.bind(this));
            },
            dismissFtp() {
                this.form.open = !this.form.open;
            },
            onChangePage (page) {
                this.$refs.vuetable.changePage(page)
            },
            onPaginationData (paginationData) {
                this.$refs.pagination.setPaginationData(paginationData)
                this.$refs.paginationInfo.setPaginationData(paginationData)
            },
            onLoaded: function () {
                this.tableLoading = false;
            },
            deleteCredential(credentialId) {
                this.deleteCredentialModal = true;
                this.credentialToDelete = credentialId;
            },
            editCredential(credential) {
                this.editedIndex = credential.id;
                this.editedItem = Object.assign({}, credential);
                this.defaultItem = Object.assign({}, credential);
            },
            saveCredential() {
                if (this.editedIndex > -1) {
                    axios.put(`${baseURL}/ftp_credentials/${this.editedIndex}`, this.editedItem).then(res => {
                        this.$nextTick(() => {
                            this.$refs.vuetable.refresh();
                        });
                    });
                }
                this.close();
            },
            close() {
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1;
                }, 300)
            },
            confirmDeleteCredential() {
                axios.delete(`${baseURL}/ftp_credentials/${this.credentialToDelete}`).then(res => {
                    if (res.status == 204) {
                        this.credentialToDelete = null;
                        this.deleteCredentialModal = false;
                        this.alert.message = 'Credential was deleted with success.';
                        this.alert.status = 'alert-success';
                        this.$nextTick(() => {
                            this.$refs.vuetable.refresh();
                        });
                    }
                });
            },
            setItems: function () {
                var cvs = this.channelvalues;
                this.channel.items = [
                    {
                        groupingName: "FTP Credentials",
                        groupItems: [
                            {
                                name: "server",
                                label: "Server",
                                required: true,
                                type: "text",
                                column: "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value: (this.getNestedProperty(cvs, 'json_options', 'credentials', 'server')) ? cvs.json_options.credentials.server : "",
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name: "username",
                                label: "Username",
                                required: true,
                                type: "text",
                                column: "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value: (this.getNestedProperty(cvs, 'json_options', 'credentials', 'username')) ? cvs.json_options.credentials.username : "",
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name: "password",
                                label: "Password",
                                required: true,
                                type: 'gated-text',
                                maskedValue: this.maskSensitiveField(this.getNestedProperty(cvs, 'json_options', 'credentials', 'password')),
                                type: "text",
                                column: "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value: (this.getNestedProperty(cvs, 'json_options', 'credentials', 'password')) ? cvs.json_options.credentials.password : "",
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name: "filepath",
                                label: "File path",
                                required: true,
                                type: "text",
                                column: "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value: (this.getNestedProperty(cvs, 'json_options', 'credentials', 'filepath')) ? cvs.json_options.credentials.filepath : "",
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name: "archived",
                                label: "File is archived?",
                                required: true,
                                type: "select",
                                column: "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value: (this.getNestedProperty(cvs, 'json_options', 'credentials', 'archived')) ? true : false,
                                options: [
                                    {
                                        'id': 1,
                                        'name': 'Yes'
                                    },
                                    {
                                        'id': 0,
                                        'name': 'No'
                                    }
                                ],
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name: "unarchived_path",
                                label: "Unarchived File Name",
                                required: false,
                                type: "text",
                                column: "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value: (this.getNestedProperty(cvs, 'json_options', 'credentials', 'unarchived_path')) ? cvs.json_options.credentials.unarchived_path : "",
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name: "separator",
                                label: "Separator",
                                required: true,
                                type: "select",
                                column: "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value: (this.getNestedProperty(cvs, 'json_options', 'credentials', 'separator')) ? cvs.json_options.credentials.separator : "comma_delimited",
                                options: [
                                    {
                                        'id': 'comma_delimited',
                                        'name': 'Comma Delimited'
                                    },
                                    {
                                        'id': 'tab_delimited',
                                        'name': 'Tab Delimited'
                                    }
                                ],
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name: "type",
                                label: "FTP/SFTP",
                                required: true,
                                type: "select",
                                column: "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value: (this.getNestedProperty(cvs, 'json_options', 'credentials', 'type')) ? cvs.json_options.credentials.type : "ftp",
                                options: [
                                    {
                                        'id': 'ftp',
                                        'name': 'ftp'
                                    },
                                    {
                                        'id': 'sftp',
                                        'name': 'sftp'
                                    }
                                ],
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name: "transformer",
                                label: "Supplier Transformer",
                                required: true,
                                type: "select",
                                column: "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value: (this.getNestedProperty(cvs, 'json_options', 'credentials', 'transformer')) ? cvs.json_options.credentials.transformer : "",
                                options: [
                                    {
                                        'id': 'IngramMicro',
                                        'name': 'IngramMicro'
                                    },
                                    {
                                        'id': 'Techdata',
                                        'name': 'Techdata'
                                    },
                                    {
                                        'id': 'Vow',
                                        'name': 'Vow'
                                    },
                                    {
                                        'id': 'OTWholesale',
                                        'name': 'OTWholesale'
                                    }
                                ],
                                tooltip: '',
                                tooltip_position: 'top'
                            }
                        ]
                    }
                ]
            }
        },
        mounted() {
            this.setItems();
        }
    };
</script>

<style scoped lang="scss">
.ftp-credentials__item-actions {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    object-fit: contain;
}
.btn-actions {
    margin-right: 0.5rem;
}
input {
    border-top-style: hidden;
    border-right-style: hidden;
    border-left-style: hidden;
    border-bottom-style: groove;
    background-color: #fff;
    width: 100%;
}
input:focus {
    outline: none;
}
</style>
